import { useAcsFetch } from '../hooks/use-acs-fetch'
import { useHostServices } from '../HostServices'
import { Preference, PreferenceData } from '../types'

export const usePreferenceApi = (): {
  getAllPreferences: () => Promise<Preference[]>
  updatePreference: (
    schemaKey: string,
    version: string,
    prefer: PreferenceData['data'],
  ) => Promise<boolean>
} => {
  const {
    session: { data: sessionData },
  } = useHostServices()
  /* istanbul ignore next */
  const guid = sessionData?.guid

  const acsFetch = useAcsFetch({ withCif: true, withGuid: true })

  // TODO: update needed here when the actual api response is finalized
  const getAllPreferences = async (): Promise<Preference[]> => {
    const response = await acsFetch<Preference[]>(
      `/v1/customers/${guid}/customizations/states`,
    )
    return response.data
  }

  const updatePreference = async (
    schemaKey: string,
    version: string,
    data: PreferenceData['data'],
  ): Promise<boolean> => {
    const requestBody = {
      schemaVersion: version,
      data,
    }
    await acsFetch<Preference>(
      `/v1/customers/${guid}/customizations/states/${schemaKey}`,
      {
        method: 'PUT',
        body: JSON.stringify(requestBody),
      },
    )
    return true
  }

  return {
    getAllPreferences,
    updatePreference,
  }
}
